// extracted by mini-css-extract-plugin
export default {"zoomControls":"x--z","zoomControlButton":"y--z","zoomBanner":"z--z","bannerButton":"A--z","imageButton":"B--z","zoom":"C--z","zoomContent":"D--z"};